export default __webpack_public_path__ + "static/media/Robots_08.b225fb33.png";